import React from 'react';
import PropTypes from 'prop-types';

import { PolarChartWidget } from '../../widgets';

import { Spinner, ErrorMessage } from '../../base';
import { CenteringDiv } from '../../base/styled';

const DeviceCountGross = (props) => {
  const {
    results: {
      error = null,
      data: { 'raw-device-counts': rawDeviceCounts = null } = {},
    } = {},
  } = props;

  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!rawDeviceCounts) {
    return <Spinner />;
  }

  return (
    <div className="dashboard">
      <CenteringDiv>
        <PolarChartWidget input={{
          error,
          data: rawDeviceCounts,
        }}
        />
      </CenteringDiv>
    </div>
  );
};

DeviceCountGross.defaultProps = null;
DeviceCountGross.propTypes = {
  results: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PolarChartWidget.dataPropType,
  }),
};

export default DeviceCountGross;
